/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const searchContentBodyActorPredicatesItemActorUuidsMax = 20;

export const searchContentBodyActorPredicatesItemActorsMax = 20;

export const searchContentBodyActorPredicatesItemEdgeTypesMax = 3;

export const searchContentBodyActorPredicatesItemQueryMax = 200;

export const searchContentBodyActorPredicatesMax = 5;

export const searchContentBodyAfterMax = 4096;

export const searchContentBodyFirstMax = 100;

export const searchContentBodyKindsMax = 2;

export const searchContentBodyMaxDepthMin = 0;
export const searchContentBodyMaxDepthMax = 10;

export const searchContentBodyOffsetMin = 0;

export const searchContentBodyPredicatesItemPathTypeUuidsMax = 8;

export const searchContentBodyPredicatesMax = 10;

export const searchContentBodyRootContentTypeUuidsMax = 20;

export const searchContentBodySearchTermsMax = 10;

export const searchContentBodySortDirectionDefault = `desc`;
export const SearchContentBody = zod.object({
  actorPredicates: zod
    .array(
      zod.object({
        actorUuids: zod
          .array(zod.uuid())
          .min(1)
          .max(searchContentBodyActorPredicatesItemActorUuidsMax)
          .optional()
          .describe('Explicit principal actor UUIDs to match (match ANY)'),
        actors: zod
          .array(
            zod.object({
              actorUuid: zod.uuid().describe('UUID v4 identifier'),
              match: zod.enum(['SELF', 'IN_SCOPE', 'ANY']),
            }),
          )
          .min(1)
          .max(searchContentBodyActorPredicatesItemActorsMax)
          .optional()
          .describe(
            'Actors with an explicit match: SELF (unscoped principal), IN_SCOPE (scoped to the actor) or ANY',
          ),
        edgeTypes: zod
          .array(zod.enum(['AUTHORED_BY', 'SHARED_WITH', 'SUBJECT_OF']))
          .min(1)
          .max(searchContentBodyActorPredicatesItemEdgeTypesMax)
          .describe(
            'Relations to match: AUTHORED_BY (author), SHARED_WITH, and\/or SUBJECT_OF (who the content is about)',
          ),
        query: zod
          .string()
          .min(1)
          .max(searchContentBodyActorPredicatesItemQueryMax)
          .optional()
          .describe(
            'Identify a user by what you can read of their profile: a case-insensitive, literal substring of a value in it (name, email, phone). Parts of a profile you cannot read never match; your own profile and login email always do. INSTANCE mode only.',
          ),
      }),
    )
    .max(searchContentBodyActorPredicatesMax)
    .optional()
    .describe(
      'Actor predicates (AND): roots authored by \/ shared with \/ about the identified actors',
    ),
  after: zod
    .string()
    .min(1)
    .max(searchContentBodyAfterMax)
    .optional()
    .describe(
      "The previous page's pageInfo.endCursor. Only valid with the same variant, sort and filters.",
    ),
  first: zod
    .int()
    .min(1)
    .max(searchContentBodyFirstMax)
    .optional()
    .describe('Page size (default 20)'),
  kinds: zod
    .array(zod.enum(['complex', 'primitive']))
    .min(1)
    .max(searchContentBodyKindsMax)
    .optional()
    .describe(
      'TYPE mode only. complex: the type has an outgoing CONTAINS or INCLUDES edge (a field, a constant or a template body); primitive: it has none',
    ),
  maxDepth: zod
    .int()
    .min(searchContentBodyMaxDepthMin)
    .max(searchContentBodyMaxDepthMax)
    .optional()
    .describe('Hydration depth for matched roots (default 3). Ignored in TYPE mode.'),
  offset: zod
    .int()
    .min(searchContentBodyOffsetMin)
    .optional()
    .describe(
      'Deprecated: positional paging (default 0). Use `after`; the two cannot be combined. A search that spans regions serves an offset only while offset + first is at most 1000.',
    ),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional()
    .describe(
      'Search in this acting context, as on \/mutate: what is readable, and each TYPE hit’s viewerPermissions, are the acting principal’s. A group’s manager passes GROUP to see what the group may edit.',
    ),
  predicates: zod
    .array(
      zod.object({
        op: zod
          .enum(['exists', 'eq', 'contains', 'gte', 'lte'])
          .describe('Comparison operator; \"exists\" matches on node presence alone'),
        pathTypeUuids: zod
          .array(zod.uuid())
          .min(1)
          .max(searchContentBodyPredicatesItemPathTypeUuidsMax)
          .describe(
            'Content-type UUID path (CONTAINS descent); last entry is the matched node type',
          ),
        value: zod.string().optional().describe('Comparison value as text (omit for \"exists\")'),
        valueType: zod
          .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
          .optional()
          .describe('How to interpret value (default STRING)'),
      }),
    )
    .max(searchContentBodyPredicatesMax)
    .optional()
    .describe(
      'Graph predicates over descendant values (AND). A node matches only if you can read it, and so must each ancestor that satisfies a path segment.',
    ),
  readVia: zod
    .enum(['any', 'public', 'direct'])
    .optional()
    .describe(
      "TYPE mode only. Where READ may come from. any (default): every principal of the acting context, as before. public: only PUBLIC, so only what everyone can read. direct: every principal but PUBLIC — your own types, types shared with you, and types shared with the members of a group you belong to — so other people's PUBLIC types stay out.",
    ),
  rootContentTypeUuids: zod
    .array(zod.uuid())
    .max(searchContentBodyRootContentTypeUuidsMax)
    .optional()
    .describe('Restrict roots to these content types'),
  searchTerms: zod
    .array(zod.string().min(1))
    .max(searchContentBodySearchTermsMax)
    .optional()
    .describe(
      'Case-insensitive literal substrings (AND), matched against the root title — or, in TYPE mode, the type name',
    ),
  sort: zod
    .object({
      direction: zod.enum(['asc', 'desc']).default(searchContentBodySortDirectionDefault),
      field: zod
        .enum(['updatedAt', 'createdAt', 'occurredAt', 'name'])
        .describe('`name` is TYPE-mode only (case-insensitive, then byte order)'),
    })
    .optional()
    .describe('Result order (default updatedAt desc)'),
  system: zod
    .boolean()
    .optional()
    .describe(
      "TYPE mode only. true: only the platform's system types; false: only the rest (types people and groups authored). Omitted: both. Each hit's isSystem says which it is.",
    ),
  variant: zod
    .enum(['INSTANCE', 'TYPE'])
    .optional()
    .describe('INSTANCE (default): content roots. TYPE: content types.'),
});

export type SearchContentBody = zod.input<typeof SearchContentBody>;
export type SearchContentBodyOutput = zod.output<typeof SearchContentBody>;
